import React from 'react';
import PropTypes from 'prop-types';

const Tag = (props) => {
  const { children, colorType } = props;
  return (
    <div className={`tag ${colorType}`}>
      {children}
    </div>
  );
};

Tag.defaultProps = {
  colorType: '',
};

Tag.propTypes = {
  colorType: PropTypes.string,
  children: PropTypes.node,
};

export default Tag;
